<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M27 21h-.15l-1.45-8.66A4 4 0 0021.46 9H17V7h3a1 1 0 001-1V4a1 1 0 00-1-1h-8a1 1 0 00-1 1v2a1 1 0 001 1h3v2h-4.46a4 4 0 00-3.94 3.34L5.15 21H5a2 2 0 00-2 2v4a2 2 0 002 2h22a2 2 0 002-2v-4a2 2 0 00-2-2zM8.57 12.67a2 2 0 012-1.67h10.89a2 2 0 012 1.67L24.82 21H7.18zM27 27H5v-4h22z"/><path d="M10 14h12v3H10zM14 26h4a1 1 0 000-2h-4a1 1 0 000 2z"/></svg>